import React, { useState } from "react";

interface StreakBannerProps {
  weeks: number;
  onClose?: () => void;
}

const StreakBanner: React.FC<StreakBannerProps> = ({
  weeks,
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    onClose?.();
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="w-full px-4 py-3 flex items-start justify-between streak-banner">
      
      {/* Left Content */}
      <div className="flex items-start gap-3">
        
        {/* Icon Box */}
        <div className="streak-banner-div flex items-center justify-center mt-1">
          <span className="text-white text-2xl">
            <img src={require("../../assets/fire-line.png")} alt="" />
          </span>
        </div>

        {/* Text Content */}
        <div>
          <h3 className="inter-regular-14 ">
            {weeks === 0 ? "No Streak Yet" : `${weeks}-Week Streak!`}
          </h3>
          <p className="inter-regular-14">
            {weeks === 0 ? (
              "Start a Streak 🔥 with activities like Challenges and Check-ins once a week!"
            ) : weeks < 10 ? (
              "Do a Check-in, Challenge, or Message once a week to keep your STREAK alive!"
            ) : weeks > 10 ? (
              "Crushing it! Don’t forget to stay active weekly to keep your STREAK alive!"
            ) : (
              "Check in weekly to keep your streak and earn bonuses."
            )}
            
          </p>
        </div>
      </div>

      {/* Close Button */}
      <button
        onClick={handleClose}
        className="w-6 h-6 flex items-center justify-center"
      >
        <img
          className="h-4 w-4"
          alt=""
          src={require("../../assets/close.png")}
        />
      </button>
    </div>
  );
};

export default StreakBanner;